import { render, staticRenderFns } from "./workload.vue?vue&type=template&id=7047a61d&scoped=true&"
import script from "./workload.vue?vue&type=script&lang=js&"
export * from "./workload.vue?vue&type=script&lang=js&"
import style0 from "./workload.vue?vue&type=style&index=0&id=7047a61d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7047a61d",
  null
  
)

export default component.exports